if (!customElements.get('newsletter-container')) {
  class NewsLetterContainer extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.Form = this.querySelector('form');

      if (this.Form) {
        this.Form.addEventListener('submit', (e) => {
          e.preventDefault(); // ❌ stop page refresh
          this.handleSubmit(e);
        });
      }
    }

    disconnectedCallback() {
      if (this.Form) {
        this.Form.removeEventListener('submit', this.handleSubmit);
      }
    }

    handleSubmit(event) {
      const formData = new FormData(this.Form);

      fetch(this.Form.action, {
        method: 'POST',
        body: formData,
        headers: {
          Accept: 'application/json'
        }
      })
        .then(() => {
          // ✅ Show success message INSIDE overlay
          this.Form.innerHTML = `
            <div class="FormRow">
              <h3 class="FormMessage SuccessMessage">
                Thank you for subscribing
              </h3>
            </div>
          `;

          // ⏱️ Refresh after 3 seconds
          setTimeout(() => {
            window.location.reload();
          }, 3000);
        })
        .catch(() => {
          alert('Something went wrong. Please try again.');
        });
    }
  }

  customElements.define('newsletter-container', NewsLetterContainer);
}
